module.exports = __webpack_public_path__ + "static/media/faq-record-doc.7e613def.svg";